import { createFileRoute } from '@tanstack/react-router';
import DataCollection from '../../../administration/src/components/Apps/AppDetails/DataCollection';
import { withModalOutlet } from '../-withModalOutlet';

export const Route = createFileRoute('/_secured/administration/apps/$appId/data-collection')({
  component: withModalOutlet(DataCollection),
});
